import React from 'react'

import GuideSummary from '@cinch/oxd-components/guide-summary/src'
import { GuideSummaryProps } from '@cinch/oxd-components/guide-summary/src/guide-summary.component'
import Link, { Appearance } from '@cinch/oxd-components/link/src'
import { Text, TextStyles } from '@cinch-labs/design-system'

import * as styles from './guides.module.css'

const Guides: React.FC<{
  guides: GuideSummaryProps[]
  i18n: Pick<Cinch.WebAppTranslations['manufacturer'], 'related' | 'viewArticles'>
}> = ({ guides, i18n }) => (
  <div data-testid="guides" className={styles.guides}>
    <Text oxford={true} className={styles.title} element={'h3'} type={TextStyles.vehicleSubTitle}>
      {i18n.related}
    </Text>
    <ul>
      {guides.map((item) => (
        <li key={item.id} data-testid="guide-item">
          <Link oxford={true} to={`/post/${item.id}`} className={styles.link} aria-label={item.headline}>
            <GuideSummary {...item} className={styles.guide} />
          </Link>
        </li>
      ))}
    </ul>
    <Link oxford={true} appearance={Appearance.tertiaryButton} to="/guides">
      {i18n.viewArticles}
    </Link>
  </div>
)

export default Guides
